import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "graph-container bg-white" }

import { ref, computed, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { checkMobile } from '../../utils/utils'
import ChartLine from './ChartLine.vue'
import AppDateRangePicker from './AppDateRangePicker.vue'
import { localeData } from '../../../../helpers/date-range'
import customRangeFn from '../../../../helpers/date-range'
import UserExam from '../../models/user_exam'
import Exam from '../../models/exam'

const redColor = 'rgb(255, 87, 51)'
const dotRedColor = '#FFB1A9'
const blueColor = 'rgb(124, 181, 236)'
const dotBlueColor = '#ACCFE5'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamDashboardChart',
  props: {
    exams: {},
    startDate: {},
    endDate: {}
  },
  setup(__props: any) {

const router = useRouter()

const props = __props

const allCompletedUserExams = computed(() => {
  let list: { userExam: UserExam; exam: Exam }[] = []
  props.exams.filter((exam) => {
    return !exam.hideResult
  }).forEach((exam) => {
    list = [
      ...list,
      ...exam.completedUserExams.map((userExam) => {
        return { userExam, exam }
      })
    ]
  })

  list.sort((a, b) => (a.userExam.createdAt > b.userExam.createdAt ? 1 : -1))

  return list
})

const userExamsInrange = computed(() => {
  return allCompletedUserExams.value.filter(
    (userExam) =>
      userExam.userExam.createdAt > new Date(dateRange.value.startDate) && userExam.userExam.createdAt < new Date(dateRange.value.endDate)
  )
})

watch(() => props.startDate, () => {
  dateRange.value.startDate = props.startDate || ''
  dateRange.value.endDate = props.endDate || ''
  updateDateRange()
})

const data = ref<{
  labels: string[];
  datasets: any[];
}>({
  labels: [],
  datasets: []
})

const options = {
  elements: {
    line: {
      tension: 0
    }
  },
  plugins: {
    legend: {
      labels: {
        usePointStyle: true,
        pointStyle: 'rect',
        boxWidth: 40,
        boxHeight: 12
      }
    }
  },
  scales: {
    x: {
      display: !checkMobile()
    },
    A: {
      type: 'linear' as const,
      position: 'left' as const,
      ticks: {
        color: redColor
      },
    },
    B: {
      type: 'linear' as const,
      position: 'right' as const,
      ticks: {
        color: blueColor,
        reverse: true
      }
    }
  }
}

const customRange = computed(() => {
  return customRangeFn()
})

const dateRange = ref({
  startDate: props.startDate || '',
  endDate: props.endDate || ''
})

const isMobile = ref(false)

onMounted(() => {
  isMobile.value = checkMobile()
  updateDateRange()
})

watch(() => props.exams, () => {
  updateDateRange()
})

const updateDateRange = async () => {
  const labels: string[] = []

  const userScore = {
    label: 'あなたのスコア',
    borderColor: redColor,
    data: [] as number[],
    fill: false,
    yAxisID: 'A',
    lineTension: 0,
  }

  const examScoreAverage = {
    label: '平均',
    borderColor: dotRedColor,
    data: [] as number[],
    fill: false,
    yAxisID: 'A',
    lineTension: 0,
    borderDash: [10, 10],
    hidden: true,
  }

  const userRank = {
    label: 'あなたの順位',
    borderColor: blueColor,
    data: [] as number[],
    fill: false,
    yAxisID: 'B',
    lineTension: 0,
    hidden: true,
  }

  const examUserCount = {
    label: '受験者数',
    borderColor: dotBlueColor,
    data: [] as number[],
    fill: false,
    yAxisID: 'B',
    lineTension: 0,
    borderDash: [10, 10],
    hidden: true,
  }

  userExamsInrange.value.forEach((userExamItem) => {
    let examName = userExamItem.exam.name
    if (examName.length > 15) {
      examName = examName.slice(0, 14) + "..."
    }

    labels.push(examName)

    userScore.data.push(userExamItem.userExam.average)
    examScoreAverage.data.push(userExamItem.exam.averageRate)
    userRank.data.push(userExamItem.userExam.position)
    examUserCount.data.push(userExamItem.exam.usersCount)
  })

  data.value = {
    labels: labels,
    datasets: [userScore, examScoreAverage, userRank, examUserCount]
  }
}

const updateRange = () => {
  let startDate = dateRange.value.startDate.toString()
  let endDate = dateRange.value.endDate.toString()
  router.push({ query: { start_date: startDate, end_date: endDate } })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppDateRangePicker, {
      onUpdate: updateRange,
      modelValue: dateRange.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
      opens: "right",
      ranges: customRange.value,
      "append-to-body": true,
      "locale-data": _unref(localeData),
      class: _normalizeClass([{ 'w-100': isMobile.value }, "mb-3"])
    }, null, 8 /* PROPS */, ["modelValue", "ranges", "locale-data", "class"]),
    (data.value.datasets.length > 0)
      ? (_openBlock(), _createBlock(ChartLine, {
          key: 0,
          class: "line-chart-container",
          width: 800,
          height: isMobile.value ? 800 : 320,
          data: data.value,
          chartOptions: options
        }, null, 8 /* PROPS */, ["height", "data"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})